var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 92,
    height: 8,
    viewBox: "0 0 92 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Arrow 1",
    d: "M91.3536 4.35355C91.5488 4.15829 91.5488 3.84171 91.3536 3.64645L88.1716 0.464466C87.9763 0.269204 87.6597 0.269204 87.4645 0.464466C87.2692 0.659728 87.2692 0.976311 87.4645 1.17157L90.2929 4L87.4645 6.82843C87.2692 7.02369 87.2692 7.34027 87.4645 7.53553C87.6597 7.7308 87.9763 7.7308 88.1716 7.53553L91.3536 4.35355ZM0 4.5H91V3.5L0 3.5L0 4.5Z",
    fill: "#2D3238"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRight);
export default __webpack_public_path__ + "static/media/arrow-right.22f4a12b47f14a7ac486a1ce0b06ac29.svg";
export { ForwardRef as ReactComponent };